
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.833 16.25a5.417 5.417 0 110-10.833 5.417 5.417 0 010 10.833zm0-2.167a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5zM17.333 5.417a1.083 1.083 0 11-2.166 0 1.083 1.083 0 012.166 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.167 0H6.5A6.5 6.5 0 000 6.5v8.667a6.5 6.5 0 006.5 6.5h8.667a6.5 6.5 0 006.5-6.5V6.5a6.5 6.5 0 00-6.5-6.5zm-13 6.5A4.333 4.333 0 016.5 2.167h8.667A4.333 4.333 0 0119.5 6.5v8.667a4.333 4.333 0 01-4.333 4.333H6.5a4.333 4.333 0 01-4.333-4.333V6.5z","fill":"currentColor"}})])
          )
        }
      }
    